document.addEventListener("DOMContentLoaded", function(){

  const reviewBox = document.getElementById("reviewBox");

  if(reviewBox){
    reviewBox.addEventListener("click", function(){
      this.classList.toggle("active");
    });
  }

});
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

document.addEventListener('click', async function (e) {
  const btn = e.target.closest('.sub-toggle');
  if (!btn) return;

  e.preventDefault();

  const wrapper = btn.closest('.cart-subscription-block');
  if (!wrapper) return;

  const line = wrapper.dataset.line;
  const variantId = wrapper.dataset.variantId;
  const quantity = parseInt(wrapper.dataset.quantity || 1);
  const type = btn.dataset.type; // onetime | subscription

  let sectionId = 'ajax-cart';
  let cartSection = null;
  const baseUrl = window.location.pathname;
  const onCartPage = baseUrl.indexOf('/cart') > -1;

  if (onCartPage) {
    cartSection = document.querySelector('[data-cart-wrapper]');
    if (cartSection) {
      sectionId = cartSection.dataset.section;
    }
  }

  let selectedPlanId = null;
  if (type === 'subscription') {
    const select = wrapper.querySelector('.subscription-interval');
    if (select) {
      selectedPlanId = select.value;
    }
  }

  btn.classList.add('loading');

  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: 0
      })
    });
  } catch (err) {
    console.error('Failed to remove cart line:', err);
    btn.classList.remove('loading');
    return;
  }

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', quantity);
  formData.append('sections', sectionId);

  if (type === 'subscription' && selectedPlanId) {
    formData.append('selling_plan', selectedPlanId);
  }

  config.body = formData;

  fetch('/cart/add.js', config)
    .then((response) => response.json())
    .then((response) => {
      btn.classList.remove('loading');

      // update cart page wrapper if section came back
      if (onCartPage && cartSection && response.sections && response.sections[sectionId]) {
        $s.updateDynamicContent(cartSection, response.sections[sectionId]);
        $s.globalEval(response.sections[sectionId]);
      }

      // always refresh side cart drawer to keep it in sync
      if (window.SideCart) {
        window.SideCart.updateSideCart(false);
      }
    })
    .catch((error) => {
      btn.classList.remove('loading');
      console.error('Subscription toggle failed:', error);
    });
});


/* =========================================
   Subscription interval change (THEME SAFE)
   ========================================= */

document.addEventListener('change', function (e) {
  const select = e.target.closest('.subscription-interval');
  if (!select) return;

  const wrapper = select.closest('.cart-subscription-block');
  if (!wrapper) return;

  const box = select.closest('.subscription-interval-box');

  const line = wrapper.dataset.line;
  const quantity = wrapper.dataset.quantity;
  const sellingPlan = select.value;

  let sectionId = 'ajax-cart';
  let cartSection = null;
  const baseUrl = window.location.pathname;
  const onCartPage = baseUrl.indexOf('/cart') > -1;

  if (onCartPage) {
    cartSection = document.querySelector('[data-cart-wrapper]');
    if (cartSection) {
      sectionId = cartSection.dataset.section;
    }
  }

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData();
  formData.append('line', line);
  formData.append('quantity', quantity);
  formData.append('selling_plan', sellingPlan);
  formData.append('sections', sectionId);

  config.body = formData;

  box?.classList.add('loading');

  fetch('/cart/change.js', config)
    .then((res) => res.json())
    .then((response) => {
      box?.classList.remove('loading');

      if (response.status) {
        console.error('Subscription update failed:', response);
        return;
      }

      if (onCartPage && cartSection && response.sections && response.sections[sectionId]) {
        $s.updateDynamicContent(cartSection, response.sections[sectionId]);
        $s.globalEval(response.sections[sectionId]);
      }

      if (window.SideCart) {
        window.SideCart.updateSideCart(false);
      }
    })
    .catch((err) => {
      box?.classList.remove('loading');
      console.error('Subscription update failed:', err);
    });
});



